import styles from './StudyQualitySection.module.css';

interface StudyQualitySectionProps {
  studyQuality?: string | null;
  diagnosisCode?: string | null;
}

export default function StudyQualitySection({
  studyQuality,
  diagnosisCode,
}: StudyQualitySectionProps) {
  return (
    <section className={styles.section}>
      <h3 className={styles.sectionTitle}>Study Quality &amp; Diagnosis</h3>
      <div className={styles.row}>
        <div className={styles.kv}>
          <span className={styles.kvLabel}>Study Quality:</span>
          <span className={styles.kvValue}>{studyQuality || '—'}</span>
        </div>
        <div className={styles.kv}>
          <span className={styles.kvLabel}>Diagnosis Code:</span>
          <span className={styles.kvValue}>{diagnosisCode || '—'}</span>
        </div>
      </div>
    </section>
  );
}
